"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Appdefs = window.cccisd && window.cccisd.appDefs;
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var _default = exports["default"] = function _default(rowActions, externalLoadData) {
  // If we don't have enough data, just return it as we got it.
  if (!Array.isArray(rowActions) || rowActions.length <= 0) {
    return rowActions;
  }

  /**
   * Higher-order function returning a function to be called by
   * `cccisd-graphql-table`'s `runRowAction` that will call the appropriate
   * api endpoint with the appropriate data for the provided action and type.
   *
   * NOTE for type 'pawn', we assume that `selectedRows` is an array of
   * `pawnId`s.
   *
   * NOTE for type 'group', we assume that `selectedRows` is an array of
   * `groupId`s
   *
   * @param {string} action The action to be performed
   * @param {string} type   The type of data ('pawn' or 'group')
   * @return {function}
   */

  var rowActionConfirmation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(loadData, type, data, action) {
      var _response$data, response, ucAction, tmId, _response$data2, _response$data3, _response$data4, _finalResult2, _finalResult2$taskPro, _finalResult3, _finalResult3$taskPro, _finalResult3$taskPro2, _finalResult4, _finalResult4$taskPro, _finalResult4$taskPro2, _finalResult6, _finalResult8, _finalResult8$taskPro, url, finalResult, loopCount, _finalResult, _finalResult$taskProg, percent, rows, _finalResult5, _finalResult5$taskPro, _finalResult5$taskPro2, _finalResult7, _finalResult7$taskPro, _finalResult7$taskPro2, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.nexus.".concat(type, ".bulk")), {
              action: action,
              data: data
            });
          case 1:
            response = _context.v;
            ucAction = action.charAt(0).toUpperCase() + action.slice(1);
            tmId = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.taskmasterId; // Few enough data values that we did not need a Taskmaster job
            if (tmId) {
              _context.n = 2;
              break;
            }
            if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === 'success') {
              (0, _cccisdNotification["default"])({
                type: 'success',
                message: "".concat(ucAction, " successful")
              });
            } else if ((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.status) === 'error') {
              (0, _cccisdNotification["default"])({
                inModal: true,
                duration: -1,
                type: 'error',
                data: (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.errors) || (response === null || response === void 0 ? void 0 : response.data),
                message: "".concat(ucAction, " request may be incomplete or did not process at all due to the following errors")
              });
            } else {
              (0, _cccisdNotification["default"])({
                duration: -1,
                type: 'warning',
                message: "Warning: ".concat(ucAction, " may have only completed partially or not at all")
              });
            }
            _context.n = 8;
            break;
          case 2:
            url = Boilerplate.route('api.taskmaster.getTask', {
              id: tmId
            });
            loopCount = 0; // after 3 seconds, quit trying
          case 3:
            _context.n = 4;
            return new Promise(function (res) {
              return setTimeout(res, 1000);
            });
          case 4:
            _context.n = 5;
            return fetch(url).then(function (res) {
              return res.json();
            });
          case 5:
            finalResult = _context.v;
            loopCount++;
          case 6:
            if (!['Complete', 'userCancelled'].includes((_finalResult = finalResult) === null || _finalResult === void 0 ? void 0 : (_finalResult$taskProg = _finalResult.taskProgress) === null || _finalResult$taskProg === void 0 ? void 0 : _finalResult$taskProg.status) && loopCount < 3) {
              _context.n = 3;
              break;
            }
          case 7:
            percent = (_finalResult2 = finalResult) === null || _finalResult2 === void 0 ? void 0 : (_finalResult2$taskPro = _finalResult2.taskProgress) === null || _finalResult2$taskPro === void 0 ? void 0 : _finalResult2$taskPro.percentage;
            rows = (_finalResult3 = finalResult) === null || _finalResult3 === void 0 ? void 0 : (_finalResult3$taskPro = _finalResult3.taskProgress) === null || _finalResult3$taskPro === void 0 ? void 0 : (_finalResult3$taskPro2 = _finalResult3$taskPro.results) === null || _finalResult3$taskPro2 === void 0 ? void 0 : _finalResult3$taskPro2.rowsComplete;
            if (((_finalResult4 = finalResult) === null || _finalResult4 === void 0 ? void 0 : (_finalResult4$taskPro = _finalResult4.taskProgress) === null || _finalResult4$taskPro === void 0 ? void 0 : (_finalResult4$taskPro2 = _finalResult4$taskPro.results) === null || _finalResult4$taskPro2 === void 0 ? void 0 : _finalResult4$taskPro2.status) === 'error') {
              (0, _cccisdNotification["default"])({
                inModal: true,
                message: "".concat(ucAction, " failed for some rows"),
                data: (_finalResult5 = finalResult) === null || _finalResult5 === void 0 ? void 0 : (_finalResult5$taskPro = _finalResult5.taskProgress) === null || _finalResult5$taskPro === void 0 ? void 0 : (_finalResult5$taskPro2 = _finalResult5$taskPro.results) === null || _finalResult5$taskPro2 === void 0 ? void 0 : _finalResult5$taskPro2.errors,
                duration: -1,
                type: 'danger'
              });
            } else if ((_finalResult6 = finalResult) !== null && _finalResult6 !== void 0 && _finalResult6.done || percent === 100) {
              (0, _cccisdNotification["default"])({
                message: "".concat(ucAction, " succeeded")
              });
            } else if (typeof percent === 'number' && typeof rows === 'number') {
              (0, _cccisdNotification["default"])({
                duration: -1,
                type: 'warning',
                message: "".concat(ucAction, " only ").concat(percent, "% processed. ").concat(rows, " row(s) of ").concat(((_finalResult7 = finalResult) === null || _finalResult7 === void 0 ? void 0 : (_finalResult7$taskPro = _finalResult7.taskProgress) === null || _finalResult7$taskPro === void 0 ? void 0 : (_finalResult7$taskPro2 = _finalResult7$taskPro.results) === null || _finalResult7$taskPro2 === void 0 ? void 0 : _finalResult7$taskPro2.totalRows) || 'total', " were processed.")
              });
            } else if (!['Complete', 'userCancelled'].includes((_finalResult8 = finalResult) === null || _finalResult8 === void 0 ? void 0 : (_finalResult8$taskPro = _finalResult8.taskProgress) === null || _finalResult8$taskPro === void 0 ? void 0 : _finalResult8$taskPro.status)) {
              (0, _cccisdNotification["default"])({
                message: "".concat(ucAction, " failed"),
                duration: -1,
                type: 'danger'
              });
            } else {
              (0, _cccisdNotification["default"])({
                duration: -1,
                type: 'warning',
                message: "".concat(ucAction, " completed only partially or not at all")
              });
            }
          case 8:
            // Now that we've completed the updates, reload the table data
            loadData();
            if (externalLoadData) {
              externalLoadData();
            }
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function rowActionConfirmation(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
  function rowActionFunctionBuilder(action, type) {
    var rowActionFunction = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
        var loadData, data, selectedRows, packagedData, selectedRowsHash, idKey, hashKey, i, row, resp, respData, message, groupAndRoleDefinitions, total, curr, label, hasMsg, thatMsg, actionMessage, descMessage;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              loadData = _ref2.loadData, data = _ref2.data, selectedRows = _ref2.selectedRows;
              packagedData = [];
              /* If few enough rows, try doing this without a Job on backend by sending hashes
               *   Uberadmin have high permissions and don't need hashes
               */
              if (!(Fortress.user.acting.role.handle !== 'uberadmin' && selectedRows.length < 10 && data.length < 1000)) {
                _context2.n = 6;
                break;
              }
              // use object for constant runtime instead of 2 nested loops
              selectedRowsHash = {};
              selectedRows.forEach(function (id) {
                selectedRowsHash[id] = true;
              });
              idKey = type === 'group' ? 'group.groupId' : 'pawn.pawnId';
              hashKey = type === 'group' ? 'group.randomHash' : 'pawn.pawnHash';
              i = 0;
            case 1:
              if (!(i < data.length)) {
                _context2.n = 5;
                break;
              }
              row = data[i];
              if (selectedRowsHash[row[idKey]]) {
                _context2.n = 2;
                break;
              }
              return _context2.a(3, 4);
            case 2:
              if (!(row[idKey] && row[hashKey])) {
                _context2.n = 3;
                break;
              }
              packagedData.push({
                id: row[idKey],
                hash: row[hashKey]
              });
              _context2.n = 4;
              break;
            case 3:
              packagedData = selectedRows;
              return _context2.a(3, 5);
            case 4:
              i++;
              _context2.n = 1;
              break;
            case 5:
              _context2.n = 7;
              break;
            case 6:
              packagedData = selectedRows;
            case 7:
              if (!(type === 'pawn' || type === 'group' && !['delete', 'archive'].includes(action))) {
                _context2.n = 8;
                break;
              }
              rowActionConfirmation(loadData, type, packagedData, action);
              return _context2.a(2);
            case 8:
              _context2.n = 9;
              return _cccisdAxios["default"].post(Boilerplate.route("api.nexus.group.descendantCount"), _defineProperty({}, action, selectedRows));
            case 9:
              resp = _context2.v;
              respData = resp.data.data;
              message = '';
              groupAndRoleDefinitions = [].concat(_toConsumableArray(Appdefs.pawn.groups), _toConsumableArray(Appdefs.pawn.roles));
              total = Object.keys(respData.descendants).length;
              curr = 1;
              respData.descendants.forEach(function (descendant) {
                var def = groupAndRoleDefinitions.find(function (p) {
                  return p.handle === descendant.handle;
                });
                if (!def) {
                  // could be relic group/role from when Appdefs had different structure.
                  // If so, no need to report it
                  return;
                }
                var label = descendant.total > 1 ? def.labelPlural : def.label;
                if (total === 1) {
                  message += " ".concat(descendant.total, " ").concat(label, " ");
                } else if (curr === total) {
                  message += " and ".concat(descendant.total, " ").concat(label, " ");
                } else {
                  message += " ".concat(descendant.total, " ").concat(label, ", ");
                  curr++;
                }
              });
              label = respData.selected.total > 1 ? groupAndRoleDefinitions.find(function (g) {
                return g.handle === respData.selected.name;
              }).labelPlural : groupAndRoleDefinitions.find(function (g) {
                return g.handle === respData.selected.name;
              }).label;
              hasMsg = '';
              if (total > 0) {
                hasMsg = selectedRows.length > 1 ? 'have' : 'has';
              }
              thatMsg = total > 0 ? 'that' : '';
              actionMessage = null;
              if (action === 'delete') {
                actionMessage = "will be deleted. Do you want to continue to delete?";
              } else if (action === 'archive') {
                actionMessage = "will be archived. You can unarchive later, if needed. Do you want to continue to archive?";
              }
              descMessage = "Selected ".concat(respData.selected.total, " ").concat(label, " ").concat(hasMsg, " ") + message.toString() + "".concat(thatMsg, " ").concat(actionMessage);
              (0, _cccisdConfirm["default"])({
                message: 'Are you sure?',
                description: descMessage
              }).then(function () {
                rowActionConfirmation(loadData, 'group', packagedData, action);
              });
            case 10:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function rowActionFunction(_x5) {
        return _ref3.apply(this, arguments);
      };
    }();
    return rowActionFunction;
  }
  var processedRowActions = [];
  var supportedActions = ['archive', 'delete', 'unarchive'];
  rowActions.forEach(function (rAction) {
    var action = rAction.action;
    if (action === 'invitePawns') {
      rAction.component = function (bulkProps) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkInvite, _extends({
          settings: rAction.settings
        }, bulkProps));
      };
      rAction.inModal = true;
    }
    if (typeof action === 'string') {
      // Currently only support bulk actions for Pawns and Groups
      var type = action.match(/Pawns$|Groups$/);
      if (type) {
        type = type[0]; // Will be 'Pawns' or 'Groups'
        var aMatch = action.split(type)[0];
        if (supportedActions.includes(aMatch)) {
          // Transform to the type expected by the api (e.g., 'pawn' from 'Pawns')
          type = type.toLowerCase().substring(0, type.length - 1);
          // We're sure that we support this action, so set the function
          rAction.action = rowActionFunctionBuilder(aMatch, type);
        }
      }
    }
    processedRowActions.push(rAction);
  });
  return processedRowActions;
};